import { SyncStatusView } from './models'
import React from 'react'
import { getIntegrationDisplayName } from '../../../../../common/integrations'

export const ExternalUpdateTitle: React.FC<{ syncStatus: SyncStatusView }> = ({ syncStatus }) => {
  const getSyncStatusTypeName = (syncStatus: SyncStatusView): string => {
    const groupLength = (syncStatus.groups?.length || 0) + 1
    const isGrouped = (syncStatus.groups?.length || 0) > 0
    switch (syncStatus.type) {
      case 'export':
        return !isGrouped ? 'Meeting' : `${groupLength} Meetings`
      case 'meetingSummary':
        return !isGrouped ? 'Meeting summary' : `${groupLength} Meeting summaries`
      case 'aiResult':
        return syncStatus.name || `${groupLength} AI result`
      case 'task':
        return !isGrouped ? 'task' : `${groupLength} tasks`
      case 'updateContact':
      case 'createContact':
        return 'contact'
      default:
        return 'data'
    }
  }

  const getExportTitle = (syncStatus: SyncStatusView) => {
    switch (syncStatus.type) {
      case 'export':
        return (
          <div>
            <b>{getSyncStatusTypeName(syncStatus)}</b> exported to {getIntegrationDisplayName(syncStatus.serviceId)}
          </div>
        )
      case 'meetingSummary':
        return (
          <div>
            Saved <b>{getSyncStatusTypeName(syncStatus)}</b> to {getIntegrationDisplayName(syncStatus.serviceId)}
          </div>
        )
      case 'aiResult':
        return (
          <div>
            Saved <b>{getSyncStatusTypeName(syncStatus)}</b> to {getIntegrationDisplayName(syncStatus.serviceId)}
          </div>
        )
      case 'task':
        return (
          <div>
            Saved <b>{getSyncStatusTypeName(syncStatus)}</b> to {getIntegrationDisplayName(syncStatus.serviceId)}
          </div>
        )
      case 'updateContact':
        return (
          <div>
            Updated <b>{syncStatus.name}</b> in {getIntegrationDisplayName(syncStatus.serviceId)}
          </div>
        )
      case 'createContact':
        return (
          <div>
            Created <b>{syncStatus.name}</b> in {getIntegrationDisplayName(syncStatus.serviceId)}
          </div>
        )
      default:
        return (
          <div>
            Saved <b>{syncStatus.name}</b> to {getIntegrationDisplayName(syncStatus.serviceId)}
          </div>
        )
    }
  }

  return <div>{getExportTitle(syncStatus)}</div>
}
